import { useCallback } from 'react'
import { useDeleteDocumentPage } from '../document_pages'
import { useResetGLTF } from '../cads'

export const useDeleteOperationStep = () => {
  const { reset: resetGLTF } = useResetGLTF()
  const { isPending, mutateAsync: deleteDocumentPage } = useDeleteDocumentPage({
    onSuccess: () => {
      resetGLTF()
    },
  })
  const mutateAsync = useCallback(
    ({ stepId }: { stepId: string }) => {
      return void deleteDocumentPage({
        documentPageId: stepId,
      })
    },
    [deleteDocumentPage],
  )

  return {
    isPending,
    mutateAsync,
  }
}
